const cache = new Map();
function formatterFor(timezone) {
    const cached = cache.get(timezone);
    if (cached)
        return cached;
    // Geçersiz IANA adı isteği ÇÖKERTMEZ: UTC'ye düşer (istemcideki `safeZone`
    // ile aynı savunma hattı).
    let zone = timezone;
    try {
        new Intl.DateTimeFormat('en-CA', { timeZone: zone });
    }
    catch {
        zone = 'UTC';
    }
    const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: zone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    });
    cache.set(timezone, formatter);
    return formatter;
}
export function zonedParts(value, timezone) {
    const parts = formatterFor(timezone).formatToParts(value);
    const pick = (type) => parts.find((part) => part.type === type)?.value ?? '00';
    return {
        day: `${pick('year')}-${pick('month')}-${pick('day')}`,
        time: `${pick('hour')}:${pick('minute')}`,
    };
}
/** `HH:mm:ss` ya da `HH:mm` → `HH:mm` (Postgres `time` kolonu saniye taşır). */
export function toHourMinute(value) {
    return value.slice(0, 5);
}
//# sourceMappingURL=zoned-time.js.map